<template>
    <div>
        <div class="quick-design-page">
            <div class="design-body">
                    <div class="design-color-size-quantity">
                        <div class="top-title">Select color,size and quantity</div>
                        <div class="style-box">
                            <div class="label-box">
                                <div class="type-label">Please select the style type</div>
                                <div class="number-label">Custom Style Number</div>
                                <div class="color-label">Color</div>
                                <div class="size-label">Size</div>
                                <div class="quantity-label">Quantity</div>
                            </div>
                            <div class="form-item" v-for="(item, index) in style_list" :key="index">
                                <div class="type-box">
                                    <div class="type-item">
                                        <select size="large" v-model="item.parent_product_category_id" @change="onChangeParentCategory($event.target.value,item.parent_product_cate_list,index)">
                                            <option value="">Please select...</option>
                                            <option v-for="(v, k) in item.parent_product_cate_list" :key="`dpc1` + k" :value="v.product_category_id">
                                                {{ v.category_name_en }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="type-item" v-show="item.sub_product_category_list.length > 0">
                                        <select v-model="item.child_product_category_id" @change="onChangeSubCategory($event.target.value,item.sub_product_category_list,index)">
                                            <option value="">Please select...</option>
                                            <option
                                                    v-for="(v, k) in item.sub_product_category_list"
                                                    :key="`dpc2` + k"
                                                    :value="v.product_category_id"
                                            >
                                                {{ v.category_name_en }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="number-box">
                                    <input @blur="onStyleNumberBlur($event.target.value, item, index)" placeholder="Enter the style number..." v-model="item.style_number"/>
                                </div>
                                <div class="color-box">
                                    <input placeholder="Enter the color..." v-model="item.color"/>
                                </div>
                                <div class="size-box">
                                    <select v-model="item.size" >
                                        <option value="">Please select...</option>
                                        <option v-for="(item, index) in item.size_list" :key="index" :value="item"
                                        >
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                                <div class="quantity-box">
                                    <input type="number" :min="1" placeholder="Enter the quantity..." v-model="item.quantity"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="design-img-list">
                        <div class="list-title">Style Design Draft</div>
                        <div class="img-list">
                            <div class="img-item" v-for="(item, index) in design.image_list" :key="index">
                                <template v-if="util.test_image(item.raw)">
                                    <img :src="item.raw" alt="" style="object-fit: cover"/>
                                </template>
                                <template v-else>
                                    <a :href="item.raw" target="_blank">
                                        <img :src="util.get_image_icon(item.raw)" alt="" style="object-fit: cover"
                                        />
                                    </a>
                                </template>
                                <img @click="deleteImage(index)" src="../../assets/images/icon-close-circle.png" alt=""
                                     class="remove-icon">
                            </div>
                            <Upload
                                    type="drag"
                                    :action="upload_url"
                                    :data="{ dir: 'template' }"
                                    multiple
                                    :before-upload="onBeforeUpload"
                                    :show-upload-list="false"
                            >
                                <div class="upload-icon">
                                    <img src="../../assets/images/icon-add-match-upload.png"/>
                                </div>
                            </Upload>
                        </div>
                    </div>
            </div>
            <div class="footer" >
                <div class="btn btn-back" @click="back">Back</div>
                <div class="btn btn-confirm" @click="submit">Confirm and submit</div>
            </div>
        </div>

        <!-- 提交成功弹窗 -->
        <popup
                :show.sync="is_success_show"
                width="500px"
                height="350px"
                class="bg-white"
                :closeable="false"
                @on-close="is_success_show = false"
        >
            <div class="success-popup">
                <img
                        src="../../assets/images/icon-success-free.png"
                        alt=""
                        class="success-icon"
                />
                <div class="success-title">Submission Successful</div>
                <div class="success-msg">
                    Your clothing customization request has been submitted,and we will
                    contact you as soon as possible to confirm the details.
                </div>
                <div class="success-btn" @click="onComplete">Complete</div>
            </div>
        </popup>
    </div>
</template>

<script>
    import {
    GetOrderDesign,
    ProductCategoryList,
    Profile,
    UpdateOrderDesign
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import util from "@/utils/util.js";

    export default {
        name: 'ModifyDesign',
        components: {
            Popup,
        },
        data() {
            return {
                util: util,
                uuid: "",
                product_category_list: [],
                sub_product_category_list: [],
                select_size_ids: [],
                design: {},
                table_data: [],
                // 主面料A的颜色数据
                raw_color_list: [
                    {
                        color_id: -1,
                        color_key: -1,
                        color_name: "Default Color",
                        color_name_en: "Default Color",
                        color_value: "",
                    },
                ],
                // 已选颜色ID
                select_color_ids: [],
                is_add_color: false,
                is_click: false,
                region: region,
                form_data_multiple: [],
                color_list_multiple: [],
                style_list: [],
                value: [],
                is_success_show: false,
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
            };
        },
        watch: {
        },
        computed: {
            count() {
                let res = 0;
                this.style_list.forEach(item => {
                    res += item.quantity;
                })

                return res;
            },
        },
        mounted() {
            const {uuid} = this.$route.query;
            if (uuid) {
                this.uuid = uuid;
            }
            this.getProductCategoryList().then(() => {
                return this.onGetOrderDesign()
            })
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // 通过 `vm` 访问组件实例
                vm.$emit("showFooter", false);
            });
        },
        beforeRouteLeave(to, from, next) {
            this.$emit("showFooter", true);
            next();
        },
        methods: {
            validateStyleList() {
                // 检查style_list是否为空
                if (!this.style_list || this.style_list.length === 0) {
                    return true;
                }

                // 遍历style_list中的每一项
                for (let i = 0; i < this.style_list.length; i++) {
                    const item = this.style_list[i];

                    // 检查每个必填字段是否为空
                    if (
                        // 检查父级分类是否选择
                        !item.parent_product_category_id ||
                        // 检查样式编号是否填写
                        !item.style_number ||
                        // 检查颜色是否填写
                        !item.color ||
                        // 检查尺寸是否选择
                        !item.size ||
                        // 检查数量是否填写且大于0
                        !item.quantity ||
                        parseInt(item.quantity) <= 0
                    ) {
                        return false;
                    }

                    // 如果有子分类列表且子分类列表不为空，检查是否选择了子分类
                    if (
                        item.sub_product_category_list &&
                        item.sub_product_category_list.length > 0 &&
                        !item.child_product_category_id
                    ) {
                        return false;
                    }
                }

                return true;
            },
            back() {
                this.$router.back();
            },
            deleteImage(index) {
                this.design.image_list.splice(index, 1);
            },
            async onBeforeUpload(file) {
                uploadFileToOSS(file, 'template').then(url => {
                    const object = {raw: url, raw_name: file.name}
                    this.design.image_list.push(object)
                })
                return false;
            },
            onStyleNumberBlur(value, data, index) {
                const {uuid} = data;
                const check = this.style_list.filter((item) => {
                    return item.uuid != uuid && item.style_number == value;
                });
                if (check && check.length > 0) {
                    this.$layer.msg(
                        "Style number is a unique string,please check your data"
                    );
                    this.style_list[index].style_number = "";
                    return;
                }
            },
            onChangeParentCategory(value, data, index) {
                const child = data.filter((item) => {
                    return item.product_category_id == value;
                })[0];
                this.style_list[index].child_product_category_id = 0;
                this.style_list[index].sub_product_category_list = [...child.children];
                this.style_list[index].size_list = [...child.size_list];
            },
            onChangeSubCategory(value, data, index) {
                const res = data.filter((item) => {
                    return item.product_category_id == value;
                })[0];
                if (res.size_list && res.size_list.length > 0) {
                    this.style_list[index].size_list = [...res.size_list];
                }
            },
            async onGetOrderDesign() {
                try {
                    const {data} = await GetOrderDesign({uuid: this.$route.query.uuid});
                    this.design = data.design_data.category;
                    let parent_category = this.product_category_list.find((v) => {
                        return v.product_category_id === this.design.parent_product_category_id
                    })
                    console.log(111, this.design)
                    let child_category = {}
                    if(this.design.child_product_category_id) {
                        child_category = parent_category.children.find((i) => {
                            return i.product_category_id === this.design.child_product_category_id;
                        })
                    }

                    let object = {
                        uuid: data.design_data.category.uuid,
                        parent_product_cate_list: [...this.product_category_list],
                        sub_product_category_list: parent_category.children.length > 0 ? parent_category.children : [],
                        parent_product_category_id: this.design.parent_product_category_id,
                        child_product_category_id: this.design.child_product_category_id,
                        style_number: this.design.name,
                        size_list: child_category.product_category_id > 0 ? child_category.size_list : parent_category.size_list,
                        quantity: data.quantity,
                        color: data.design_data.color_list[0].color_name,
                        size: Object.keys(data.design_data.size_list)[0],
                    }
                    this.style_list.push(object)
                } catch (e) {
                    console.log("e===>getDraft", e);
                }
            },
            submit() {
                if (this.is_click) {
                    return;
                }

                if (!this.design.image_list.length) {
                    this.$layer.msg('Please upload image or file');
                    return;
                }

                if (!this.validateStyleList()) {
                    this.$layer.msg('Please fill the style info');
                    return;
                }

                if (!this.style_list.length || this.style_list.length < 1) {
                    this.$layer.msg('Please add at least one style')
                    return;
                }

                const img = this.design.image_list.filter((item) => {
                    const name = item.raw_name.split('.').pop();
                    return ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(name);
                })[0];

                const data = {};
                const color = {};

                this.style_list.forEach((item) => {
                    const color_uuid = util.uuid();

                    // 确保 data[item.uuid] 存在
                    if (!data[item.uuid]) {
                        data[item.uuid] = {};
                    }

                    // 设置 category 信息
                    data[item.uuid]["category"] = {
                        product_category_id: item.child_product_category_id ? item.child_product_category_id : item.parent_product_category_id,
                        parent_product_category_id: item.parent_product_category_id,
                        child_product_category_id: item.child_product_category_id,
                        name: item.style_number,
                        image_list: this.design.image_list,
                        key: item.uuid,
                        image: img && img.raw ? img.raw : ''
                    };

                    // 确保 table_data 对象存在
                    if (!data[item.uuid]["table_data"]) {
                        data[item.uuid]["table_data"] = {};
                    }

                    // 确保特定尺寸的对象存在
                    if (!data[item.uuid]["table_data"][item.size]) {
                        data[item.uuid]["table_data"][item.size] = {};
                    }

                    // 设置 table_data 信息
                    data[item.uuid]["table_data"][item.size] = {
                        size: {
                            size_key: item.size,
                            size_alias: item.size,
                        },
                        color: {
                            [color_uuid]: {
                                color_id: color_uuid,
                                color_key: color_uuid,
                                color_name: item.color,
                                color_name_en: item.color,
                                quantity: item.quantity,
                                type: 1,
                                color_value: "",
                            },
                        },
                        complete: {},
                    };

                    if (!data[item.uuid]["select_size_ids"]) {
                        data[item.uuid]["select_size_ids"] = [];
                    }

                    data[item.uuid]["select_size_ids"].push(item.size);

                    if (!data[item.uuid]["select_color_ids"]) {
                        data[item.uuid]["select_color_ids"] = [];
                    }

                    data[item.uuid]["select_color_ids"].push(color_uuid);

                    // 设置 color 信息
                    if (!color[item.uuid]) {
                        color[item.uuid] = {};
                    }

                    color[item.uuid] = [
                        {
                            color_id: color_uuid,
                            color_key: color_uuid,
                            color_name: item.color,
                            color_name_en: item.color,
                            color_value: "",
                            type: 1,
                        },
                    ];
                });
                console.log("data", data);
                console.log("color", color);
                this.form_data_multiple = data;
                this.color_list_multiple = color;
                // return;
                const param = {};
                param.uuid = this.uuid;
                param.form_data_multiple = data;
                param.color_list_multiple = color;

                // return;
                if (this.count < 1) {
                    this.$layer.msg(
                        `Please enter the quantity of customized clothing required`
                    );
                    return;
                }

                this.confirm_submit();
            },
            async confirm_submit() {
                const param = {};
                param.form_data_multiple = this.form_data_multiple;
                param.color_list_multiple = this.color_list_multiple;
                param.uuid = this.$route.query.uuid;
                console.log("param", param);
                // return;
                this.is_click = true;
                this.$Spin.show();
                UpdateOrderDesign(param).then((response) => {
                    if (response.code > 0) {
                        this.$layer.msg(response.msg)
                        this.$Spin.hide();
                        return
                    }
                    this.is_success_show = true;
                }).then(() => {
                }).catch((res) => {
                    console.log('err', res)
                    this.$layer.msg(res);
                }).finally(() => {
                    this.$Spin.hide();
                    setTimeout(() => {
                        this.is_click = false;
                    }, 500);
                });
            },
            onComplete() {
                this.is_success_show = false;
                this.$router.replace({name: 'OrderCenter'});
            },
            async getProfile() {
                return Profile().then((response) => {
                    return response;
                });
            },
            blur($e, v) {
                let temp = $e.target.value;
                if (isNaN(temp)) {
                    v.val = v.normal;
                }
                temp = parseFloat(temp);
                if (temp < parseFloat(v.normal) + parseFloat(v.min)) {
                    v.val = parseFloat(v.normal) + parseFloat(v.min);
                }
                if (temp > parseFloat(v.normal) + parseFloat(v.max)) {
                    v.val = parseFloat(v.normal) + parseFloat(v.max);
                }
                v.val = Math.round(v.val * 10) / 10;
            },
            async getProductCategoryList() {
                const {data} = await ProductCategoryList();
                this.product_category_list = data
                return data
            },
        },
    };
</script>
<style lang="scss" scoped>
    .quick-design-page {
        width: 100%;
        min-height: 100vh;
        background: rgb(245, 246, 245);
        // padding-bottom:200px;
        // margin-bottom:200px;
        display: flex;
        justify-content: center;

        .design-body {
            width: 100%;
            max-width: 1200px;
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            margin-top: 8px;

            .design-color-size-quantity {
                width: 100%;
                background: #ffffff;
                padding: 30px 40px 50px 30px;

                .top-title {
                    width: 100%;
                    color: #333333;
                    font-size: 20px;
                    font-weight: bold;
                    padding-bottom: 18px;
                    border-bottom: 1px solid #ebebeb;
                }

                .style-box {
                    width: 100%;
                    margin-top: 25px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    row-gap: 8px;
                    // column-gap: 10px;
                    .label-box {
                        display: flex;
                        align-items: center;
                        width: 100%;
                        font-weight: bold;
                        font-size: 14px;
                        padding: 0 10px;
                        column-gap: 10px;

                        .type-label {
                            width: 100%;
                            max-width: 340px;
                        }

                        .number-label {
                            width: 100%;
                            max-width: 190px;
                        }

                        .color-label {
                            width: 100%;
                            max-width: 170px;
                        }

                        .size-label {
                            width: 100%;
                            max-width: 170px;
                        }

                        .quantity-label {
                            width: 100%;
                            max-width: 150px;
                        }
                    }

                    .form-item {
                        width: 100%;
                        background: #fafafa;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                        padding: 15px 10px;
                        margin-top: 10px;

                        .type-box,
                        .number-box,
                        .color-box,
                        .size-box,
                        .quantity-box {
                            border: 1px solid #dad5d1;
                            background: #ffffff;
                            height: 52px;
                            border-radius: 5px;
                            width: 100%;
                            overflow: hidden;

                            input {
                                border: none;
                                outline: none;
                                width: 100%;
                                height: 100%;
                                padding: 0 5px;
                            }
                        }

                        .type-box {
                            max-width: 339px;
                            display: flex;
                            align-items: center;

                            .type-item {
                                flex: 1;
                                height: 100%;

                                &:first-child {
                                    // border-right:1px solid #dad5d1;
                                }

                                &:last-child {
                                    border-left: 1px solid #dad5d1;
                                }

                                padding: 0 18px;

                                select {
                                    width: 100%;
                                    height: 100%;
                                    border: none;
                                    outline: none;
                                }
                            }
                        }

                        .number-box {
                            max-width: 190px;
                        }

                        .color-box,
                        .size-box {
                            max-width: 170px;
                        }

                        .size-box {
                            padding: 0 5px;

                            select {
                                border: none;
                                outline: none;
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .quantity-box {
                            max-width: 150px;
                        }

                        .del-ico {
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                        }
                    }

                    .style-number {
                        display: flex;
                        flex-direction: column;
                        row-gap: 10px;

                        .label {
                            color: #1a1a1a;
                            font-size: 15px;
                            font-weight: 500;
                        }

                        .input {
                            width: 190px;
                            height: 52px;
                            border-radius: 5px;
                            border: 1px solid #dad5d1;
                            padding: 0 18px;
                        }
                    }

                    .type-select {
                        display: flex;
                        flex-direction: column;
                        row-gap: 10px;
                        width: 100%;
                        max-width: 340px;

                        .label {
                            color: #1a1a1a;
                            font-size: 15px;
                            font-weight: 500;
                        }

                        .input-box {
                            display: flex;
                            align-items: center;
                            // column-gap: 5px;
                            height: 52px;

                            .select-item {
                                flex: 1;
                                height: 100%;
                                border-radius: 5px;
                                border: 1px solid #dad5d1;
                                padding: 0 18px;

                                select {
                                    width: 100%;
                                    height: 100%;
                                    border: none;
                                    outline: none;
                                }
                            }
                        }
                    }
                }

                .add-more-btn {
                    width: 100%;
                    border-bottom: 1px solid #e5e5e5;
                    padding-bottom: 27px;
                    margin-top: 20px;

                    .more-btn {
                        display: flex;
                        align-items: center;
                        column-gap: 8px;
                        margin-left: 10px;
                        width: fit-content;
                        cursor: pointer;

                        .add-ico {
                            width: 18px;
                            height: 18px;
                        }

                        .btn-text {
                            font-size: 14px;
                            color: #2162a1;
                        }
                    }
                }

                .note-info-title {
                    width: 100%;
                    margin-top: 25px;
                    font-weight: bold;
                    color: #333333;
                    font-size: 14px;
                    margin-left: 10px;
                }

                .note-info-box {
                    width: 100%;
                    padding: 13px 10px 0 10px;

                    .note-box {
                        width: 100%;
                        height: 110px;
                        border-radius: 5px;
                        border: 1px solid #dad5d1;
                        overflow: hidden;

                        textarea {
                            width: 100%;
                            height: 100%;
                            border: none;
                            outline: none;
                            padding: 10px;
                        }
                    }
                }

                .label-title {
                    color: #1a1a1a;
                    font-size: 15px;
                    font-weight: 500;
                    margin-top: 40px;
                }

                .table {
                    width: 100%;
                    margin-top: 10px;
                    table-layout: fixed;
                    text-align: center;
                    border-collapse: collapse;
                    display: block;
                    overflow-x: auto;
                    white-space: nowrap;
                    border-right: 1px solid #e2e5e9;
                    box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.1);

                    th,
                    td {
                        box-sizing: border-box;
                    }

                    th:first-child,
                    td:first-child {
                        position: sticky;
                        left: 0;
                        z-index: 10;
                        background: #f8f8f9;
                    }

                    .size {
                        width: 160px;
                    }

                    .color {
                        width: 130px;
                    }

                    .complete {
                        width: 130px;
                    }

                    .input {
                        text-align: center;
                        outline: none;
                        border: 1px solid #e2e5e9;
                        width: 100%;
                    }

                    th {
                        padding: 0 5px;
                        height: 50px;
                        line-height: 50px;
                        background: #f8f8f9;
                        border: 1px solid #e2e5e9;

                        &.color {
                            color: #fa3d5a;
                        }

                        .icon-edit {
                            width: 12px;
                            height: 12px;
                            margin: 0 10px;
                        }
                    }

                    td {
                        padding: 2px 5px;
                        height: 50px;
                        line-height: 50px;
                        border: 1px solid #e2e5e9;
                        font-size: 15px;

                        .icon-edit {
                            width: 12px;
                            height: 12px;
                            margin: 0 10px;
                        }
                    }
                }
            }

            .pick-address-box {
                width: 1200px;
                background: #ffffff;
                padding: 32px 40px 50px 40px;

                .pick-title {
                    color: #333333;
                    font-size: 20px;
                    font-weight: bold;
                    padding-bottom: 20px;
                    border-bottom: 1px solid #e5e5e5;
                }

                .address-list {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    row-gap: 10px;

                    .item-box {
                        display: flex;
                        align-items: center;
                        // justify-content:space-between;
                        padding-bottom: 27px;
                        border-bottom: 1px solid #e5e5e5;
                        margin-top: 30px;
                        padding-right: 5%;
                        flex: 1 0 50%;

                        .address-item {
                            display: flex;
                            flex-direction: column;
                            line-height: 1.5;
                            // height:3em;
                            margin-left: 10px;
                            cursor: pointer;

                            .name {
                                color: #000000;
                                font-size: 14px;
                                font-weight: bolder;
                            }

                            .address,
                            .phone {
                                color: #333333;
                                font-size: 14px;
                                line-height: 1.5;
                                height: 3em;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                /*! autoprefixer: ignore next */
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                // max-height: 6em; /* 4行 * 1.5行高 = 6em */
                                word-wrap: break-word;
                                word-break: break-all;
                            }

                            .btn-box {
                                display: flex;
                                align-items: center;

                                .btn-item {
                                    color: #808080;
                                    font-size: 12px;
                                    cursor: pointer;

                                    &:first-child {
                                        padding-right: 15px;
                                    }

                                    &:last-child {
                                        padding-left: 15px;
                                    }

                                    &:hover {
                                        color: #2162a1;
                                        text-decoration: underline;
                                    }
                                }

                                .line {
                                    width: 1px;
                                    height: 15px;
                                    background: #808080;
                                }
                            }
                        }
                    }
                }

                .add-btn {
                    width: 280px;
                    height: 52px;
                    margin-top: 30px;
                    border: 1px solid #dad5d1;
                    border-radius: 26px;
                    text-align: center;
                    line-height: 52px;
                    color: #1a1a1a;
                    font-size: 14px;
                    cursor: pointer;
                }
            }

            .design-img-list {
                width: 1200px;
                background: #ffffff;
                padding: 32px 40px 50px 40px;
                margin-bottom: 200px;

                .list-title {
                    color: #333333;
                    font-weight: bold;
                    font-size: 20px;
                    margin-bottom: 36px;
                }

                .img-list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;

                    .img-item {
                        width: 150px;
                        height: 150px;
                        border: 1px solid #ebebeb;
                        position: relative;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        .remove-icon {
                            width: 22px;
                            height: 22px;
                            position: absolute;
                            top: 5px;
                            right: 5px;
                        }
                    }

                    .upload-icon {
                        width: 150px;
                        height: 150px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 32px;
                            height: 32px;
                        }
                    }
                }
            }

            .custom-order-details {
                width: 100%;
                background: #ffffff;
                padding: 30px 40px 50px 30px;
                margin-bottom: 200px;

                .detail-title {
                    color: #333333;
                    font-size: 20px;
                    font-weight: bold;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 20px;
                    margin-bottom: 40px;

                    th,
                    td {
                        border-right: none;
                        border-left: none;
                        border-top: 1px solid #e2e5e9;
                        border-bottom: 1px solid #e2e5e9;
                        padding: 12px 8px;
                        text-align: left;
                    }

                    thead th {
                        // background-color: #f8f8f9;
                        color: #666666;
                        font-size: 14px;
                        text-align: left;
                        font-weight: bold;
                        border-top: none;
                    }

                    // 移除 tbody 中单元格的上边框，只保留下边框
                    tbody td {
                        border-top: none;
                        text-align: left;
                        color: #1a1a1a;
                        font-size: 14px;
                    }
                }

                .img-list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                    margin-top: 36px;
                    margin-bottom: 50px;

                    .img-item {
                        width: 150px;
                        height: 150px;
                        border: 1px solid #ebebeb;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .shipping-info {
                    width: 100%;
                    background: #fafafa;
                    margin-top: 20px;
                    margin-bottom: 40px;

                    .info-container {
                        padding: 27px 20px;
                        display: flex;
                        justify-content: space-between;

                        .info-box {
                            display: flex;
                            flex-direction: column;

                            .name {
                                color: #000000;
                                font-size: 14px;
                                font-weight: 500;
                            }

                            .other {
                                color: #333333;
                                font-size: 14px;
                            }
                        }

                        .change-btn {
                            color: #808080;
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                }

                .note-info {
                    width: 100%;
                    background: #fafafa;
                    margin-top: 20px;
                    margin-bottom: 100px;

                    .info-container {
                        padding: 27px 20px;
                        color: #333333;
                        font-size: 14px;
                    }
                }
            }

            .select-address {
                width: 100%;
                background: #ffffff;
                padding: 30px 40px 50px 30px;
                margin-bottom: 200px;

                .select-add-title {
                    color: #333333;
                    font-size: 20px;
                    font-weight: bold;
                    width: 100%;
                    border-bottom: 1px solid #e5e5e5;
                    padding-bottom: 20px;
                }

                .address-list {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    row-gap: 10px;

                    .item-box {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding-bottom: 27px;
                        border-bottom: 1px solid #e5e5e5;
                        margin-top: 30px;
                        width: 100%;

                        .address-item {
                            display: flex;
                            flex-direction: column;
                            line-height: 1.5;
                            margin-left: 10px;
                            cursor: pointer;

                            .name {
                                color: #000000;
                                font-size: 14px;
                                font-weight: bolder;
                            }

                            .address,
                            .phone {
                                color: #333333;
                                font-size: 14px;
                            }
                        }

                        .btn-box {
                            display: flex;
                            align-items: center;
                            flex-wrap: nowrap;

                            .btn-item {
                                color: #808080;
                                font-size: 12px;
                                cursor: pointer;

                                &:first-child {
                                    padding-right: 15px;
                                }

                                &:last-child {
                                    padding-left: 15px;
                                }

                                &:hover {
                                    color: #2162a1;
                                    text-decoration: underline;
                                }
                            }

                            .line {
                                width: 1px;
                                height: 15px;
                                background: #808080;
                            }
                        }
                    }
                }

                .add-new-btn {
                    color: #3872ab;
                    font-size: 14px;
                    margin-top: 30px;
                    margin-left: 40px;
                    cursor: pointer;
                }

                .select-address-btn {
                    width: 320px;
                    height: 52px;
                    background: #222222;
                    border-radius: 26px;
                    color: #ffffff;
                    line-height: 52px;
                    text-align: center;
                    margin-top: 80px;
                    cursor: pointer;
                }
            }
        }

        .footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100px;
            background: white;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            z-index: 10;

            .btn {
                height: 38px;
                line-height: 38px;
                border-radius: 19px;
                font-size: 14px;
                padding: 0 20px;
                cursor: pointer;

                &.btn-confirm {
                    width: 200px;
                    background: #fa3d5a;
                    color: white;
                    text-align: center;
                }

                &.btn-back {
                    // width: 120px;
                    margin-right: 20px;
                    background: #ebebeb;
                    color: #1c1f23;
                    text-align: center;
                }
            }
        }
    }

    .success-popup {
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .success-icon {
            width: 66px;
            height: 66px;
            margin-bottom: 30px;
        }

        .success-title {
            color: #333333;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
        }

        .success-msg {
            text-align: center;
            color: #333333;
            font-size: 14px;
            padding: 0 30px;
            margin-bottom: 58px;
        }

        .success-btn {
            width: 200px;
            height: 46px;
            border-radius: 6px;
            background: #fa3d5a;
            color: #ffffff;
            line-height: 46px;
            text-align: center;
            cursor: pointer;
        }
    }
</style>
